import React, { useEffect, useState } from "react";
import { MDBBtn, MDBModalFooter, MDBSpinner } from "mdb-react-ui-kit";
import { useNavigate } from "react-router";
import { getPhoneMultiSaveOptions, savePhoneMultiSave } from "../../../apiclients/streamsapi_bridge";
import PopupLoader from "../PopupLoader";
import MultiSaveLimitAlert from "../../../apiclients/MultiSaveLimitAlert";

const PHChangeLocation = (props) => {
  const [allLocations, setAllLocations] = useState([]);
  const [location, setlocation] = useState(-1);
  const [error, setError] = useState("");
  const [isloading, setIsloading] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [saveWarningMessage, setSaveWarningMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetchLocations();
  }, []);

  async function fetchLocations() {
    setIsloading(true);
    try {
      const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      const params = {
        reqid: 186,
        siteid,
        phone_numbers: props.phNumList,
        option_type: 3,
      };
      const serverResponse = await getPhoneMultiSaveOptions(params);
      if (serverResponse.ok) {
        const responseData = await serverResponse.json();
        setAllLocations(responseData.result?.option_list || []);
      }
    } catch (err) {
      console.log("Error fetching locations:", err);
    }
    setIsloading(false);
  }

  async function handleSave(confirmFlag) {
    if (parseInt(location) === -1) {
      setError("Please select a Location");
      return;
    }
    setError("");
    setIsloading(true);
    try {
      const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      const update = {
        reqid: 186,
        siteid,
        phone_numbers: props.phNumList,
        option_type: 3,
        option_value: location + "",
      };
      const serverResponse = await savePhoneMultiSave(update, confirmFlag);
      if (serverResponse.ok) {
        const responseData = await serverResponse.json();
        if (responseData.status === "failed" && responseData.exceededErrMsg) {
          setSaveWarningMessage(responseData.exceededErrMsg);
          setShowWarning(true);
          setIsloading(false);
          return;
        } else if (responseData.status === "success") {
          localStorage.setItem("s_message", responseData.message);
          props.onClose();
          navigate("/phonenumbers", { state: { tab: props.sourceTab } });
          window.location.reload();
          return;
        }
      }
    } catch (err) {
      console.log("Error changing location:", err);
    }
    setIsloading(false);
  }

  return (
    <>
      {isloading && (
        <div className="loadingclass">
          <MDBBtn disabled>
            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
            Loading...
          </MDBBtn>
        </div>
      )}
      <div style={{ minHeight: "120px" }}>
        <strong className="d-block">Change Location</strong>
        <select
          className="form-select form-control w-100 mt-2"
          value={location}
          onChange={(e) => {
            setlocation(e.target.value);
            if (parseInt(e.target.value) === -1) {
              setError("Please select a Location");
            } else {
              setError("");
            }
          }}
        >
          <option value={-1}>-- Select Location --</option>
          {allLocations.map((loc) => (
            <option key={loc.loc_id} value={loc.loc_id}>{loc.loc_name}</option>
          ))}
        </select>
        {error && (
          <p className="text-danger mb-0 mt-1">{error}</p>
        )}
      </div>
      <MDBModalFooter className="p-0 pt-3" style={{ borderTop: "1px solid #dee2e6" }}>
        <MDBBtn color="secondary" onClick={props.onClose}>
          Cancel
        </MDBBtn>
        <MDBBtn onClick={() => handleSave(false)}>
          Save Changes
        </MDBBtn>
      </MDBModalFooter>
      {showWarning && (
        <PopupLoader
          title="Warning"
          content={
            <MultiSaveLimitAlert
              saveWarningMessage={saveWarningMessage}
              onClose={() => setShowWarning(false)}
              handleClick={() => {
                setShowWarning(false);
                handleSave(true);
              }}
            />
          }
          onShow={setShowWarning}
          onClose={() => setShowWarning(false)}
        />
      )}
    </>
  );
};

export default PHChangeLocation;
